import Maplat from "../parts/Maplat.png";
import allright from "../parts/all_right_reserved.png";
import attr from "../parts/attr.png";
import basemap from "../parts/basemap.png";
import blueM from "../parts/blue_marker.png";
import blueD from "../parts/bluedot.png";
import blueD_s from "../parts/bluedot_small.png";
import blueD_t from "../parts/bluedot_transparent.png";
import border from "../parts/border.png";
import cc0 from "../parts/cc0.png";
import ccbnn from "../parts/cc_by-nc-nd.png";
import ccbns from "../parts/cc_by-nc-sa.png";
import ccbnc from "../parts/cc_by-nc.png";
import ccbnd from "../parts/cc_by-nd.png";
import ccbs from "../parts/cc_by-sa.png";
import ccb from "../parts/cc_by.png";
import compass from "../parts/compass.png";
import defPin from "../parts/defaultpin.png";
import defPin_s from "../parts/defaultpin_selected.png";
import favicon from "../parts/favicon.png";
import fullscreen from "../parts/fullscreen.png";
import gps from "../parts/gps.png";
import gsi from "../parts/gsi.jpg";
import ortho from "../parts/gsi_ortho.jpg";
import help from "../parts/help.png";
import hide from "../parts/hide_marker.png";
import home from "../parts/home.png";
import loading from "../parts/loading.png";
import loading_i from "../parts/loading_image.png";
import minus from "../parts/minus.png";
import noimg from "../parts/no_image.png";
import osm from "../parts/osm.jpg";
import overlay from "../parts/overlay.png";
import pd from "../parts/pd.png";
import plus from "../parts/plus.png";
import redM from "../parts/red_marker.png";
import redC from "../parts/redcircle.png";
import share from "../parts/share.png";
import slider from "../parts/slider.png";
export default {
  "Maplat.png": Maplat,
  "all_right_reserved.png": allright,
  "attr.png": attr,
  "basemap.png": basemap,
  "blue_marker.png": blueM,
  "bluedot.png": blueD,
  "bluedot_small.png": blueD_s,
  "bluedot_transparent.png": blueD_t,
  "border.png": border,
  "cc0.png": cc0,
  "cc_by-nc-nd.png": ccbnn,
  "cc_by-nc-sa.png": ccbns,
  "cc_by-nc.png": ccbnc,
  "cc_by-nd.png": ccbnd,
  "cc_by-sa.png": ccbs,
  "cc_by.png": ccb,
  "compass.png": compass,
  "defaultpin.png": defPin,
  "defaultpin_selected.png": defPin_s,
  "favicon.png": favicon,
  "fullscreen.png": fullscreen,
  "gps.png": gps,
  "gsi.jpg": gsi,
  "gsi_ortho.jpg": ortho,
  "help.png": help,
  "hide_marker.png": hide,
  "home.png": home,
  "loading.png": loading,
  "loading_image.png": loading_i,
  "minus.png": minus,
  "no_image.png": noimg,
  "osm.jpg": osm,
  "overlay.png": overlay,
  "pd.png": pd,
  "plus.png": plus,
  "red_marker.png": redM,
  "redcircle.png": redC,
  "share.png": share,
  "slider.png": slider
};